import { FC, Dispatch, SetStateAction, useEffect, useState } from 'react';
import { MenuConfig } from 'alurkerja-ui';
import { useLocation } from 'react-router-dom';
import { useGetMenu } from '@/utils/configs/menu';
import RenderLogo from './RenderLogo';
import Sidebar from '@/components/shared/sidebar/Sidebar';
import SwitchButton from '@/components/company/SwitchButton';
import { axiosInstance } from '@/utils/lib/axios';
import { env } from '@/utils/constants/env';
import { toast } from 'react-toastify';
import { Globe } from 'lucide-react';
import useTenantState from '@/states/tenant.state';

interface MenuWrapperProps {
  children: JSX.Element;
  menu: MenuConfig;
}

interface ExtendedSidebarProps {
  toggled: boolean;
  setToggled: Dispatch<SetStateAction<boolean>>;
  menuWrapper: (props: MenuWrapperProps) => JSX.Element;
}

export const ExtendedSidebar: FC<ExtendedSidebarProps> = ({ setToggled, toggled, menuWrapper }) => {
  const { pathname } = useLocation();
  const { filteredMenu: menu } = useGetMenu();
  const { currentTenant } = useTenantState();
  const [isComproPublished, setIsComproPublished] = useState(false);

  useEffect(() => {
    if (currentTenant?.id) {
      fetchPublishStatus();
    }
  }, [currentTenant?.id]);

  const fetchPublishStatus = async () => {
    if (!currentTenant?.id) return;
    try {
      const url = `${env.apiTasklistBaseUrl}/api/v1/compro/tenant/${currentTenant.id}/publish-microsite`;
      const { data } = await axiosInstance.get(url);
      setIsComproPublished(data.data.is_compro_published);
    } catch (error) {
      console.error('Failed to fetch publish status:', error);
    }
  };

  const handlePublishToggle = async (value: boolean) => {
    if (!currentTenant?.id) return;
    try {
      const url = `${env.apiTasklistBaseUrl}/api/v1/compro/tenant/${currentTenant.id}/publish-microsite`;
      await axiosInstance.put(url, { is_compro_published: value });
      setIsComproPublished(value);
      toast.success(value ? 'Company profile dipublish sebagai microsite' : 'Company profile di-unpublish dari microsite');
    } catch (error) {
      console.error('Failed to update publish status:', error);
      toast.error('Gagal mengubah status publish');
    }
  };

  return (
    <div className="fixed left-0 z-50 ">
      <Sidebar
        logo={<RenderLogo />}
        toggled={toggled}
        setToggled={setToggled}
        menuConfig={menu}
        currentPathName={pathname}
        menuWrapper={menuWrapper}
      >
        {/* Publish Toggle - shown before menu items */}
        {!toggled && (
          <div className="px-4 py-3 mb-2 mx-2 bg-white rounded-lg border border-gray-200 shadow-sm">
            <div className="flex items-center justify-between gap-2">
              <div className="flex items-center gap-2 min-w-0">
                <Globe size={14} className="text-gray-500 flex-shrink-0" />
                <span className="text-xs font-medium text-gray-600 truncate">
                  Publish Microsite
                </span>
              </div>
              <SwitchButton
                checked={isComproPublished}
                onChange={handlePublishToggle}
              />
            </div>
          </div>
        )}
      </Sidebar>
    </div>
  );
};
